import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { esFolio } from "app/logic/guias";

export class QRIndex extends React.PureComponent {
    onChange = () => { }
    onResponse = async (qr: string | undefined) => {
        if(qr == null) {
            history.go("/");
        } else {
            //Interpretamos el QR:
            if(qr.startsWith("go:")) {
                history.go(qr.substr(3));
            } else if (esFolio(qr)) {
                await kea.message("Guia " + qr);
            } else {
                await kea.message("QR inválido", "El QR no fue generado para ser leido por la plataforma", "error");
            }
        }
    }
    render() {
        return (
            <kea.ModalQR value={undefined} onClose={this.onResponse} onChange={this.onChange} params={{ titulo: "Leer QR" }} />
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/qr/index.tsx